export default __webpack_public_path__ + "static/media/Highlight.ec1fec30.png";